import { UploadErrorType, UploadValidationErrors } from "./upload.types";
import React, { Fragment } from "react";
import { FormattedMessage } from "react-intl";
import { ACCEPTED_FILE_TYPES } from "../../blockPage.constants";

export const getImage = (file: File): Promise<string> => {
  return new Promise((resolve, reject) => {
    const src = window.URL.createObjectURL(file);
    let img = new Image();

    img.onload = () => resolve(src);
    img.onerror = reject;
    img.src = src;
  });
};

const acceptedFileTypes = Object.keys(ACCEPTED_FILE_TYPES)
  .join(", ")
  .toLowerCase();

export const IMAGE_VALIDATION_ERRORS: UploadValidationErrors = {
  IMAGE_TYPE: {
    type: UploadErrorType.ImageTypeNotSupported,
    message: (
      <Fragment>
        <FormattedMessage id="image_type_not_supported" /> &nbsp;
        <FormattedMessage id="supported_types_are" />
        {acceptedFileTypes}
      </Fragment>
    ),
    shortMessage: <FormattedMessage id="image_type_not_supported" />,
  },
};
